import {selector, selectorFamily} from 'recoil';

import {currentCompanyIdState} from './../company/atoms';
import {
  contactPersonsToSubmitState,
  currentContactPersonIdState,
  contactPersonsOfCompanyQueryTrigger,
  contactPersonsOfCompanyState,
} from './atoms';

import {CompanyService} from './../../api/services/company.service';

import {IContactPerson, IContactPersonToSubmit} from './../../shared/types/person.types';
import {IPartyPartyRel} from '../../shared/types/party.types';

export const currentContactPersonToSubmitSelector = selector({
  key: 'currentContactPersonToSubmitSelector',
  get: ({get}) => {
    const contactPersons = get(contactPersonsToSubmitState);
    const index = get(currentContactPersonIdState);

    return contactPersons.find((i) => i.id === index) as IContactPersonToSubmit;
  },
});

export const currentContactPersonSelector = selector({
  key: 'currentContactPersonSelector',
  get: ({get}) => {
    const contactPersons = get(contactPersonsOfCompanyState);
    const index = get(currentContactPersonIdState);

    return contactPersons.find((i) => i.id === index) as IContactPerson;
  },
});

export const contactPersonsOfCompanyQuery = selector({
  key: 'contactPersonsOfCompanyQuery',
  get: async ({get}) => {
    const id = get(currentCompanyIdState);
    get(contactPersonsOfCompanyQueryTrigger);

    if (!id) return [];

    const res = await CompanyService.getContactPersons(id);

    return res.data;
  },

  set: ({set}, newValue) => {
    set(contactPersonsOfCompanyState, newValue);
  },
});

export const contactPersonsOfCompanyFamilyQuery = selectorFamily({
  key: 'contactPersonsOfCompanyFamilyQuery',
  get:
    (id) =>
    async ({get}) => {
      get(contactPersonsOfCompanyQueryTrigger);

      if (!id) return [];

      const res = await CompanyService.getContactPersons(String(id));

      return res.data;
    },

  set:
    (id) =>
    ({set}, newValue) => {
      set(contactPersonsOfCompanyState, newValue);
    },
});

export const partyRelOfContactPersonSelector = selector({
  key: 'partyRelOfContactPersonSelector',
  get: ({get}) => {
    const currentCompanyId = get(currentCompanyIdState);
    const contactPerson = get(currentContactPersonSelector);

    return contactPerson.relations.find((item) => item.toId === currentCompanyId) as IPartyPartyRel;
  },
});

export const partyRelOfContactPersonSelectorFamily = selectorFamily({
  key: 'partyRelOfContactPersonSelectorFamily',
  get:
    (id: string) =>
    ({get}) => {
      const currentCompanyId = get(currentCompanyIdState);
      const contactPersons = get(contactPersonsOfCompanyState);

      return contactPersons
        .find((item) => item.id === id)
        ?.relations.find((item) => item.toId === currentCompanyId) as IPartyPartyRel;
    },
});
